import { supabaseClient } from '@/utils/supabase-client';

export const recipeTagApi = {
  /**
   * Get all tags for an organisation
   */
  getOrganisationTags: (organisationId: string) => {
    return supabaseClient
      .from('recipe_tag')
      .select('*')
      .eq('organisation_id', organisationId)
      .order('title');
  },

  /**
   * Get tags for a specific recipe
   */
  getRecipeTags: (recipeId: string, organisationId: string) => {
    return supabaseClient
      .from('recipe_tag_association')
      .select(
        `
          tag_id,
          recipe_tag!inner(*)
        `,
      )
      .eq('recipe_id', recipeId)
      .eq('organisation_id', organisationId);
  },
} as const;
